import { resetUserLocalStorage } from '@utils/localStorage'
import { useCallback } from 'react'
import { resetApolloClient } from 'src/apolloClient'
import { nhost } from 'src/nhost'

export default function useUserSignOut() {
  return useCallback(() => {
    // Clear local state immediately (don't wait for API)
    nhost.clearSession()
    resetApolloClient().catch(() => {})
    resetUserLocalStorage()
    // Try server-side signout in background (non-blocking)
    nhost.auth.signOut({}).catch(() => {})
    // Force reload to clean state
    window.location.href = '/'
  }, [])
}
